import { useEffect, useState } from "react";
import { Box, Flex, IconButton, Image, Stack } from "@chakra-ui/react";
import { NavLink, useLocation } from "react-router-dom";
import * as routesNames from "../../constants/routes";
import MyDiv from "./sidebar.style";
import { useAuth } from "../../hooks/useAuth";
import HomeIcon from "../../assets/images/home.svg";
import CollapseIcon from "../../assets/images/CollapseOn.svg";
import CollapseLogo from "../../assets/images/CollapseLogo.svg";
import Logo from "../../assets/images/idea-logo.png";
import IdeaICon from "../../assets/images/Idea_Sidebar_Icon.svg";


type SubMenuItem = {
  id: number;
  label: string;
  link: string;
};

type MenuItem = {
  id: number;
  menuName: string;
  menuLogo: string;
  link?: string;
  subMenu?: SubMenuItem[];
};

interface sidebarProps {
  toggleSidebar: any,
  handleSidePanel: any,
  activePortal: any
}

const Sidebar = (props: sidebarProps) => {
  const location = useLocation();
  const Menus: MenuItem[] = [];
  const RequirementMenus: MenuItem[] = [];
  const ConsumerMenus: MenuItem[] = [];
  const menus = props.activePortal === "hrlense" ? Menus : props.activePortal === "Recruitment" ? RequirementMenus : ConsumerMenus;

  const { hasPermission } = useAuth();
  const [menuId, setMenuId] = useState<number | null>(null);

  if (hasPermission('Dashboard'))
    Menus.push({ id: 1, menuName: "Dashboard", menuLogo: HomeIcon, link: routesNames.DASHBOARD, });
  if (hasPermission('Idea')) {
    const SubMenu: SubMenuItem[] = [];
    if (hasPermission('Idea', "IdeaList")) SubMenu.push({ id: 20, label: 'Ideas', link: routesNames.IDEALIST, });
    if (hasPermission('Idea', "MyIdeas")) SubMenu.push({ id: 21, label: 'My Ideas', link: routesNames.MYIDEAS, });
    Menus.push({ id: 2, menuName: "Ideas", menuLogo: IdeaICon, subMenu: SubMenu, });
  }


  // const navigate = useNavigate();
  useEffect(() => {
    const activeItem = menus.find(
      (item) =>
        item.link === location.pathname ||
        item.subMenu?.some((sub) => sub.link === location.pathname)
    );
    if (activeItem) {
      setMenuId(activeItem.id);
    }
  }, [location.pathname, menus]);

  const handleMenu = (itemId: number) => {
    const selectedItem = menus.find(item => item.id === itemId);

    // If clicking the same menu item that's already active
    if (menuId === itemId) {
      // If it has submenus, keep it expanded (don't toggle)
      if (selectedItem?.subMenu) {
        return;
      }
      // If it doesn't have submenus, keep it selected
      return;
    }

    // If the menu has a subMenu and no subMenu is currently active, redirect to its first submenu
    if (
      selectedItem?.subMenu &&
      !selectedItem.subMenu.some((sub) => sub.link === location.pathname)
    ) {
      const firstSubLink = selectedItem.subMenu[0]?.link;
      if (firstSubLink) {
        window.history.pushState({}, '', firstSubLink);
        window.dispatchEvent(new PopStateEvent('popstate'));
      }
    }

    setMenuId(itemId);
  };

  // const handleLogoClick = () => {
  //   if (props.activePortal === "hrlense") {
  //     navigate(routesNames.DASHBOARD);
  //   } else {
  //     navigate(routesNames.RecruitmentDashboard);
  //   }
  // };
  const handleLogoClick = () => {
    // if (props.activePortal === "hrlense") {
    //   navigate(routesNames.DASHBOARD);
    // } else if (props.activePortal === "Recruitment") {
    //   navigate(routesNames.RecruitmentDashboard);
    // } else if (props.activePortal === "consumer") {
    //   navigate(routesNames.CONSUMERDASHBOARD);
    // }
  };

  return (
    <MyDiv>
      <Box className={props.toggleSidebar ? "sidebar_collapse" : "sidebar_wrapper"}>
        <Box className="collapse-button">
          <IconButton className={props.toggleSidebar ? "" : "collpase_icon"} onClick={props.handleSidePanel} icon={<Image src={CollapseIcon} w={"30px"} />} aria-label={""} />
        </Box>
        <Box>
          <Flex className="top_header" style={{ justifyContent: props.toggleSidebar ? "center" : "" }}>
            {props.toggleSidebar ? (
              <Image src={CollapseLogo} className="col" cursor={'pointer'} onClick={handleLogoClick} />
            ) : (
              <Image src={Logo} className="logo" cursor={'pointer'} onClick={handleLogoClick} />
            )}
          </Flex>
          <Box className={props.toggleSidebar ? "sidebar_box_toggle" : "sidebar_box"}>
            <Stack spacing="3" className="menu_box">
              {menus.map((item) => {
                const isActiveMenu = item.id === menuId;
                const hasSubMenu = item.subMenu?.length;
                const isExpanded = isActiveMenu && hasSubMenu;

                return (
                  <Box key={item.id}>
                    <Flex className={isActiveMenu ? "active_menu menu_item" : "menu_item"} onClick={() => handleMenu(item.id)}>
                      <NavLink to={item.link ?? ""} className="font-poppins font_dark" style={{ justifyContent: props.toggleSidebar ? "center" : "" }}>
                        <Image src={item.menuLogo} className="icon_size" />
                        {!props.toggleSidebar && item.menuName}
                      </NavLink>
                    </Flex>

                    {isExpanded && !props.toggleSidebar && (
                      <Box className="submenu_wrapper">
                        {item.subMenu?.map((subItem) => {
                          const isSubActive = location.pathname === subItem.link;
                          return (
                            <NavLink key={subItem.id} to={subItem.link} className={isSubActive ? "active_submenu submenu_item" : "submenu_item"}>
                              • {subItem.label}
                            </NavLink>
                          );
                        })}
                      </Box>
                    )}
                  </Box>
                );
              })}
            </Stack>
          </Box>
        </Box>
      </Box>
    </MyDiv>
  );
};

export default Sidebar;